import React, { Component } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import { setPopUp } from 'actions/environment';
import emailjs from 'emailjs-com';

import styles from './FormRegistration.scss';
import { Select } from './Select';
import Button from '../../common/Button/Button';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import debounce from 'lodash.debounce';
import { gaEvent, trackGA } from 'services/ga';
import { Link } from 'react-router-dom';

const emailReg =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class FormRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: '',
      isButtonDisabled: true,
      name: '',
      nameError: false,
      surName: '',
      surNameError: false,
      currentWork: '',
      currentWorkError: false,
      phoneNumber: props.phone || '',
      phoneNumberError: false,
      email: '',
      emailError: false,
      city: 'Сочи',
      isAgreed: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);

    this.debouncedEnterNameEvent = debounce(this.trackInputEvent.bind(this, 'imya'), 3000);
    this.debouncedEnterSurnameEvent = debounce(this.trackInputEvent.bind(this, 'familiya'), 3000);
    this.debouncedEnterPhoneEvent = debounce(this.trackInputEvent.bind(this, 'telefon'), 3000);
    this.debouncedEnterEmailEvent = debounce(this.trackInputEvent.bind(this, 'email'), 3000);
  }

  handleCheckboxChange = (e) => {
    this.setState({ isAgreed: e.target.checked });
  };

  handleInputChange({ target }) {
    const { value } = target;
    const { key } = target.dataset;

    const minLength = key === 'phoneNumber' ? 6 : 3;

    switch (key) {
      case 'name':
        this.debouncedEnterNameEvent.cancel();
        break;
      case 'surName':
        this.debouncedEnterSurnameEvent.cancel();
        break;
      case 'phoneNumber':
        this.debouncedEnterPhoneEvent.cancel();
        break;
      case 'email':
        this.debouncedEnterEmailEvent.cancel();
        break;
      default:
        break;
    }

    this.setState({ [key]: value }, () => {
      if (value.length >= minLength) {
        switch (key) {
          case 'name':
            this.debouncedEnterNameEvent();
            break;
          case 'surName':
            this.debouncedEnterSurnameEvent();
            break;
          case 'phoneNumber':
            this.debouncedEnterPhoneEvent();
            break;
          case 'email':
            this.debouncedEnterEmailEvent();
            break;
          default:
            break;
        }
      }
    });
  }

  handleButtonClick(e) {
    const { name, surName, phoneNumber, email, currentWork, city } = this.state;
    const nameError = /[^A-Za-zа-яА-ЯёЁ]+/.test(name);
    const surNameError = /[^A-Za-zа-яА-ЯёЁ]+/.test(surName);
    const emailError = !emailReg.test(email.toLowerCase());
    const phoneNumberError = phoneNumber.length < 16;
    const currentWorkError = currentWork.length === 0;
    const isError = nameError || surNameError || emailError || phoneNumberError || currentWorkError;

    trackGA(gaEvent.registrationButtonsClick({ eventLabel: 'otpravit' }));

    e.preventDefault();
    if (isError) {
      this.setState({
        nameError,
        surNameError,
        phoneNumberError,
        emailError,
        currentWorkError,
      });

      if (emailError) {
        trackGA(gaEvent.registrationErrorsShow({ eventLabel: 'nekorrektnyi_email' }));
      }
      if (nameError) {
        trackGA(gaEvent.registrationErrorsShow({ eventLabel: 'nekorrektnoe_imya' }));
      }
      if (surNameError) {
        trackGA(gaEvent.registrationErrorsShow({ eventLabel: 'nekorrektnaya_familiya' }));
      }
    } else {
      tracker.sendEvent('Web_User_Registration');
      trackGA(gaEvent.registrationSuccess());
      this.sendEmail({ name, surName, phoneNumber, email, currentWork, city });
    }
  }

  async sendEmail(userInfo) {
    const referral = localStorage.getItem('ref');

    const BITRIX_URL = `https://bitned.ru/rest/1/gv41cfcxbxhxwn28/crm.lead.add.json?FIELDS[TITLE]=Заявка на регистрацию ${userInfo.phoneNumber}&FIELDS[NAME]=${userInfo.name}&FIELDS[LAST_NAME]=${userInfo.surName}&FIELDS[EMAIL][0][VALUE]=${userInfo.email}&FIELDS[EMAIL][0][VALUE_TYPE]=WORK&FIELDS[PHONE][0][VALUE]=${userInfo.phoneNumber}&FIELDS[PHONE][0][VALUE_TYPE]=WORK&FIELDS[COMMENTS]=Место работы: ${userInfo.currentWork}; Город: ${userInfo.city}, Реферал: ${referral}&FIELDS[SOURCE_ID]=9683008522&FIELDS[SOURCE_DESCRIPTION]=Все обьекты_Сайт_app.nedvex.ru_Регистрация в Nedvex App`;

    this.setState({ isLoading: true });
    const { t } = this.props;

    try {
      emailjs
        .send(
          'service_zymp8wm',
          'template_6il5vuh',
          { ref: referral, ...userInfo },
          'user_htj8iGWJNHzX84IftFgix'
        )
        .then(
          () => {},
          (error) => {}
        );

      await fetch(BITRIX_URL);
      this.props.handleRegistrationSuccessfully();

      this.props.setPopUp(
        <div className={styles.RegisterSuccessPopup}>
          <div className={styles.RegisterSuccessTitle}>{t('epics.registrationSuccessTitle')}</div>
          <div className={styles.RegisterSuccessSubtitle}>
            {t('epics.registrationSuccessSubtitle')}
          </div>
          <button
            className={cn(styles.OkBtn, 'button-primary', 'button-primary--lg')}
            onClick={() => this.props.setPopUp()}
          >
            OK
          </button>
        </div>,
        {
          closeStyleName: 'Default',
          contentStyleName: 'Default',
          contentClassName: styles.PrintPopupContent,
          disableBackgroundClick: true,
          hideCloseIcon: true,
        }
      );
      // dispatch({ type: 'REGISTRATION_SUCCESS' });
    } catch (error) {
      this.props.handleRegistrationError(error);
    }
  }

  trackInputEvent(inputName) {
    trackGA(gaEvent.registrationFormInput({ eventLabel: inputName }));
  }

  trackDropdownClickEvent(dropdownName) {
    trackGA(gaEvent.registrationDropdownClick({ eventLabel: dropdownName }));
  }

  trackDropdownOptionClickEvent({ dropdownName }) {
    const { city, currentWork } = this.state;
    let trackOption;

    if (dropdownName === 'mesto_raboty') {
      switch (currentWork) {
        case 'Частный агент':
          trackOption = 'chastnyi_agent';
          break;
        case 'Работаю в агентстве недвижимости':
          trackOption = 'agentstvo_nedvizhimosti';
          break;
        case 'Хочу подключить свое агентство':
          trackOption = 'svoe_agentstvo';
          break;
        default:
          break;
      }
    } else {
      switch (city) {
        case 'Сочи':
          trackOption = 'sochi';
          break;
        case 'Краснодар':
          trackOption = 'krasnodar';
          break;
        case 'Анталья':
          trackOption = 'antaliya';
          break;
        case 'Бали':
          trackOption = 'bali';
          break;
        case 'Анапа':
          trackOption = 'anapa';
          break;
        default:
          break;
      }
    }

    trackGA(
      gaEvent.registrationDropdownOptionClick({
        eventLabel: trackOption,
        eventContent: dropdownName,
      })
    );
  }

  render() {
    const { handleCloseModal, t } = this.props;

    const {
      isLoading,
      name,
      nameError,
      surName,
      surNameError,
      currentWork,
      currentWorkError,
      phoneNumber,
      phoneNumberError,
      email,
      emailError,
      city,
    } = this.state;

    const workOptions = [
      i18n.t('components.login.formRegistration.workOptions1'),
      i18n.t('components.login.formRegistration.workOptions2'),
      i18n.t('components.login.formRegistration.workOptions3'),
    ];

    const isButtonDisabled =
      !city ||
      name.length === 0 ||
      surName.length === 0 ||
      phoneNumber.length === 0 ||
      email.length === 0 ||
      !this.state.isAgreed;

    return (
      <div className={styles.Overlay}>
        <div className={styles.Modal}>
          <div
            className={styles.CloseButton}
            onClick={() => {
              handleCloseModal();
              trackGA(gaEvent.registrationButtonsClick({ eventLabel: 'zakryt' }));
            }}
          />
          <span className={styles.Title}>{t('components.login.formRegistration.title')}</span>
          <form role="form">
            <div className={cn(styles.Input, nameError && styles.InputError)}>
              <label htmlFor="name">
                {nameError ? t('components.login.formRegistration.nameError') : ''}
              </label>
              <InputMask
                id="name"
                data-key="name"
                value={name}
                placeholder={t('components.login.formRegistration.name')}
                onChange={this.handleInputChange}
              />
            </div>
            <div className={cn(styles.Input, surNameError && styles.InputError)}>
              <label htmlFor="surName">
                {surNameError ? t('components.login.formRegistration.surNameError') : ''}
              </label>
              <InputMask
                id="surName"
                value={surName}
                data-key="surName"
                placeholder={t('components.login.formRegistration.surName')}
                onChange={this.handleInputChange}
              />
            </div>
            <span className={styles.WorkTypeSpan}>
              {t('components.login.formRegistration.currentWork')}
            </span>
            <label htmlFor="currentWork">
              {currentWorkError ? t('components.login.formRegistration.currentWorkError') : ''}
            </label>
            <Select
              style={{ marginBottom: '5px' }}
              id="currentWork"
              data-key="currentWork"
              isError={currentWorkError}
              placeholder="—"
              value={currentWork}
              options={workOptions}
              onChange={(value) => {
                this.setState({ currentWork: value }, () => {
                  this.trackDropdownOptionClickEvent({ dropdownName: 'mesto_raboty' });
                });
              }}
              onClick={() => this.trackDropdownClickEvent('mesto_raboty')}
            />
            <div className={cn(styles.Input, phoneNumberError && styles.InputError)}>
              <label htmlFor="FormNumber-phone">
                {phoneNumberError ? t('components.login.formRegistration.phoneNumberError') : ''}
              </label>
              <InputMask
                type="tel"
                id="FormNumber-phone"
                data-key="phoneNumber"
                value={phoneNumber}
                placeholder="+7 (999) 999 99 99"
                onChange={this.handleInputChange}
                mask="+7 999 999 99 99"
                maskChar=""
              />
            </div>
            <div className={cn(styles.Input, emailError && styles.InputError)}>
              <label htmlFor="email">
                {emailError ? t('components.login.formRegistration.emailError') : ''}
              </label>
              <InputMask
                type="email"
                id="email"
                data-key="email"
                value={email}
                placeholder={t('components.login.formRegistration.email')}
                onChange={this.handleInputChange}
                mask=""
                maskChar=""
              />
            </div>
            <div className={styles.CheckboxWrapper}>
              <label className={styles.CheckboxPolitician}>
                <input
                  className={styles.Checkbox}
                  type="checkbox"
                  checked={this.state.isAgreed}
                  onChange={this.handleCheckboxChange}
                />
                <span>{'- '}</span>
                <span className={styles.CheckboxPoliticianLink}>
                  {t('components.login.formRegistration.checkboxText')}
                </span>
                <Link to="policy" className={styles.PoliticianLink} target="_blank">
                  {t('components.login.formRegistration.politicianLink')}
                </Link>
                {t('components.login.formRegistration.and')}
                <Link to="eula" className={styles.PoliticianLink} target="_blank">
                  {t('components.login.formRegistration.eulaLink')}
                </Link>
              </label>
            </div>
            {isLoading ? (
              <div className={styles.Wrapper}>
                <div className={styles.Loader} />
              </div>
            ) : (
              <Button
                type="submit"
                className={styles.SubmitButton}
                disabled={isLoading || isButtonDisabled}
                onClick={this.handleButtonClick}
              >
                {t('components.login.formRegistration.send')}
              </Button>
            )}
          </form>
          {/* <span className={styles.Politician}>
            {t('components.login.formRegistration.agree')}
            <Link to="policy" className={styles.PoliticianLink} target="_blank">
              {t('components.login.formRegistration.politicianLink')}
            </Link>
            {' и '}
            <Link to="eula" className={styles.PoliticianLink} target="_blank">
              {t('components.login.formRegistration.eulaLink')}
            </Link>
          </span> */}
        </div>
      </div>
    );
  }
}

export default connect(null, {
  setPopUp,
})(withTranslation()(FormRegistration));



// WEBPACK FOOTER //
// ./src/components/Login/FormRegistration/FormRegistration.js